export default "__VITE_ASSET__DXQ4sGYv__"